const localisations = {
    currentAllocationsTable: {
        columns: {
            product: {
                headerName: "Product",
                description: "",
            },
            quantity: {
                headerName: "Quantity",
                description: "",
            },
        },
    },
    allocationHistoryTable: {
        transactionTypes: [ "Adjustment", "Movement", "PutAway", "Ordered", "Order Suspended" ],
        columns: {
            product: {
                headerName: "Product",
                description: "",
            },
            quantityDelta: {
                headerName: "Quantity",
                description: "",
            },
            transactionType: {
                headerName: "Type",
                description: "",
            },
            datetime: {
                headerName: "Date/Time",
                description: "",
            },
            origin: {
                headerName: "Origin",
                description: "",
            },
            destination: {
                headerName: "Destination",
                description: "",
            },
            user: {
                headerName: "Who",
                description: "",
            },
        },
    },
    addManagedProduct : {
        warningText: "Only new products with no stock in the warehouse should be made partition-managed.",
        markProductAsManagedButtonText: "Make Partition-Managed",
        errorTitle: "Unable to set product as partition-managed",
        serverErrors: {},
    },
    addMultipleManagedProducts : {
        productsSearchLabel: "Products",
        resultsHeading: "Results",
        productsSearchButton: "Search Products",
        switchLabel: "Multi product search",
        instructionText: "Enter up to 50 product SKUs, 1 per line (will only find exact matches)",
        nonManagedProductsText: "Products that will be made partition-managed",
        markProductsAsManagedButtonText: "Make All Partition-Managed*",
        markProductsAsManagedExplanation: "*Will make all the above products partition-managed",
        markProductAsManagedButtonText: "Make Partition-Managed",
        alreadyManagedProductsText: "Products that are already partition-managed, so won't change",
        notFoundProductsText: "Products that were not recognised",
        noValidItems: "No products found with the entered skus",
        all: "All",
        productIdHeader: "Product ID",
        productSkuHeader: "Product SKU",
        productDescriptionHeader: "Description",
        productManagedStatusHeader: "Is Partition Managed",
        rowsPerPage: "Rows per page",
        productNotFound: "Product not found",
        noProductsFound: "No products found",
        noNonManagedProductsText: "Updated all products/no products to update found",
        noNotFoundProductsText: "All products were found",
        noAlreadyManagedProductsText: "No products that are already partition-managed were found",
        nonManagedProductsTabHeader: "Non-Managed",
        alreadyManagedProductsTabHeader: "Already Managed",
        notFoundProductsTabHeader: "Not Found",
        tooManySkus: "Too many SKUs entered, please reduce to 50",
        errorUpdatingProducts:"Error updating products to partition-managed"

    },
    managedProductStatus : {
        managed: "Product is partition-managed and can only exist within a partition.",
        unmanaged: "Product is NOT partition-managed and can not be in a partition."
    },
    transferStock : {
        managedProductStatus: "Product is partition managed and can be transferred.",
        productNotInPartitionStatus: "Product is not found in this partition",
        sufficientQuantityStatus: "There is sufficient stock to be transferred.",
        insufficientQuantityStatus: "There is insufficient stock to be transferred."
    },
    adjustStock : {
        sufficientQuantityStatus: "There is sufficient stock to be adjusted.",
        negativeQuantityStatus: "Adjustment would result in a negative quantity.",
        zeroQuantityStatus: "Adjustment would result no change in quantity.",
        insufficientQuantityStatus: "There is insufficient stock to be adjusted."
    }
};

export default localisations;
